'use client';

import React from 'react';
import { IBrand } from '@mybestbrands/types';
import Link from 'next/link';
import styles from '@/app/ui/components/brands/searchbrands/searchstyle.module.scss';
import { useTranslation } from 'next-i18next';

export function SearchBrandResult(props: { results: IBrand[] }) {
  const { t } = useTranslation('navigation');

  return (
    <div className={`d-flex justify-content-center  ${styles.mainContainer}`}>
      <div className={`border border-dark border-1  ${styles.container}`}>
        <ul>
          {props.results.map((result, index) => {
            return (
              <Link
                key={index}
                className={`text-decoration-none d-block text-black  ${styles.links}`}
                href={`/${t('navigation:BRANDS').toLowerCase()}/${result.brandSlug}`}>
                {result.brandName}
              </Link>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
